enum FeatureNames {
    rhipeEnabled = 'CloudAccountType:Rhipe',
    enableCloudIntelligence = 'EnableCloudIntelligence',
    pax8AzureEnabled = 'CloudAccountType:AzurePax8'
}
export default FeatureNames;